import React from "react";

const TableHead = ({
  columnSearch,
  setColumnSearch,
  onColumnFiltersChange,
  setIsSearching
}) => {
  return (
    <thead>
      <tr>
        <th className="text-left pb-0 text-[10px]">Rule Name</th>
        <th className="text-left pb-0 text-[10px]">Rule Phase</th>
<th className="text-left pb-0 whitespace-nowrap text-[10px]">
  DQ Dimension
</th>
<th className="text-left pb-0 whitespace-nowrap text-[10px] w-[100px]">
  Dataset / Table
</th>
<th className="text-left pb-0 text-[10px] whitespace-nowrap">
  ERROR% vs THRESHOLD%
</th>
        <th className="text-left pb-0 text-[10px]">Breach Date</th>
        <th className="text-left pb-0 text-[10px]">Status</th>
        <th className="text-left pb-0 text-[10px]">Owner</th>
        <th className="text-left pb-0 text-[10px]">Ticket</th>
      </tr>

      <tr>
        {/* Rule Name */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.ruleName}
            onChange={(e) => {
              const updated = { ...columnSearch, ruleName: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Rule Phase */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.rulePhase}
            onChange={(e) => {
              const updated = { ...columnSearch, rulePhase: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* DQ Dimension */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.dqDimension}
            onChange={(e) => {
              const updated = { ...columnSearch, dqDimension: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Dataset / Table */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.dataAssetName}
            onChange={(e) => {
              const updated = { ...columnSearch, dataAssetName: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* ERROR% vs Threshold */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.failPercentageVsThreshold}
            onChange={(e) => {
              const updated = { ...columnSearch, failPercentageVsThreshold: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Breach Date */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.breachDate}
            onChange={(e) => {
              const updated = { ...columnSearch, breachDate: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Status */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.Status}
            onChange={(e) => {
              const updated = { ...columnSearch, Status: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Owner */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.ruleOwner}
            onChange={(e) => {
              const updated = { ...columnSearch, ruleOwner: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>

        {/* Ticket */}
        <th>
          <input
            className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
            placeholder="Search"
            value={columnSearch.Ticket}
            onChange={(e) => {
              const updated = { ...columnSearch, Ticket: e.target.value };
              setColumnSearch(updated);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsSearching(true);
                onColumnFiltersChange({ ...columnSearch });
              }
            }}
          />
        </th>
      </tr>
    </thead>
  );
};

export default TableHead;
